import { maisIntegridade, mapa, sisbi, fabrica } from "../../assets/images";
import Footer from "../../components/footer";
import {
  BannerText,
  BannerWrapper,
  BoxImageContainer,
  BoxImageMaisIntegridade,
  BoxImageMapa,
  BoxImageSisbi,
  BoxTextContainer,
  ButtonContatos,
  ContainerImg,
  ContatosESelosContainer,
  GridContainer,
  HomeContainer,
  InfoCard,
  InfoContainer,
  InfoContainerUm,
  InfoText,
  InfoTitle,
} from "./styles";

const infoCards = [
  {
    title: "Atitude de Dono",
    texts: [
      "Agimos com responsabilidade e comprometimento em cada decisão. Cuidamos da Suprema Charque como quem cuida do que é seu, buscando sempre o melhor resultado para nossos clientes, parceiros e equipe.",
    ],
  },
  {
    title: "Disciplina",
    texts: [
      "Mantemos o foco em fazer bem feito todos os dias. Acreditamos que a disciplina nos processos garante qualidade, segurança e consistência em tudo o que entregamos.",
    ],
  },
  {
    title: "Disponibilidade",
    texts: [
      "Estamos sempre prontos para ouvir, apoiar e atender com agilidade. Valorizamos a proximidade com nossos clientes e parceiros, porque sabemos que confiança se constrói no dia a dia.",
    ],
  },
  {
    title: "Determinação",
    texts: [
      "Enfrentamos desafios com coragem e persistência. Nossa determinação nos impulsiona a evoluir continuamente, superando obstáculos e buscando sempre novos caminhos de crescimento.",
    ],
  },
  {
    title: "Franqueza",
    texts: [
      "A transparência é a base das nossas relações. Falamos com clareza e honestidade, fortalecendo laços de confiança dentro da nossa equipe e com todos que se conectam à Suprema Charque.",
    ],
  },
  {
    title: "Simplicidade",
    texts: [
      "Valorizamos o essencial e acreditamos que as melhores soluções nascem da simplicidade. É com esse olhar direto e objetivo que conduzimos nossas ações e nos aproximamos das pessoas.",
    ],
  },
  {
    title: "Humildade",
    texts: [
      "Reconhecemos que sempre há algo novo a aprender. Trabalhamos com respeito, ouvindo e valorizando cada pessoa, porque acreditamos que o verdadeiro crescimento acontece junto.",
    ],
  },
];

const Historia = () => {
  return (
    <HomeContainer>
      <BannerWrapper>
        <BannerText>
          Por
          <br /> Dentro da
          <br /> Nossa Missão
          <br /> e Valores
        </BannerText>
      </BannerWrapper>

      <InfoContainerUm>
        <InfoCard>
          <InfoTitle>Sobre a Suprema Charque</InfoTitle>
          <InfoText>
            A Suprema Charque nasceu com um propósito simples e verdadeiro:
            levar à mesa de milhares de famílias a tradição e o sabor autêntico
            do charque brasileiro. Desde o início, unimos experiência, cuidado e
            dedicação para oferecer um produto de qualidade superior, que
            preserva o sabor da carne e a confiança de nossos clientes. Ao longo
            da nossa trajetória, construímos uma relação sólida com revendedores
            e consumidores, sempre pautada pelo respeito, transparência e
            compromisso com a excelência. Cada etapa da produção é
            cuidadosamente acompanhada para garantir que o resultado final seja
            um produto confiável, saboroso e digno de carregar o nome Suprema.
            Mais do que produzir charque, nossa missão é valorizar a cultura e a
            tradição de um alimento que faz parte da história do Brasil,
            mantendo viva essa herança e fortalecendo laços de confiança com
            quem acredita no nosso trabalho. Suprema Charque: tradição,
            qualidade e confiança que se renovam a cada geração.
          </InfoText>
        </InfoCard>

        <InfoCard>
          <InfoTitle>Nossa Missão</InfoTitle>
          <InfoText>
            Nossa missão é oferecer um charque de qualidade superior, que
            preserve o sabor autêntico da tradição brasileira e proporcione
            confiança em cada entrega. Trabalhamos para fortalecer a relação com
            nossos parceiros e clientes, garantindo produtos que unem sabor,
            segurança e excelência. Mais do que produzir alimentos, buscamos
            valorizar nossa cultura, gerar desenvolvimento e manter vivo o
            legado do charque como parte da história e da mesa das famílias
            brasileiras.
          </InfoText>
        </InfoCard>
      </InfoContainerUm>

      <InfoContainer>
        <GridContainer>
          {infoCards.map((card, index) => (
            <InfoCard key={index}>
              <InfoTitle>{card.title}</InfoTitle>
              {card.texts.map((text, i) => (
                <InfoText key={i}>{text}</InfoText>
              ))}
            </InfoCard>
          ))}
        </GridContainer>
      </InfoContainer>

      <ContainerImg>
        <img src={fabrica} alt="Fábrica" />
      </ContainerImg>

      <ContatosESelosContainer>
        <BoxTextContainer>
          <div>
            <h2>Vamos fazer negócios?</h2>
            <p>Fale com um especialista</p>
          </div>
          <ButtonContatos
            onClick={() => {
              window.location.href = "/contact-us";
            }}
          >
            CONTATO
          </ButtonContatos>
        </BoxTextContainer>
        <BoxImageContainer>
          <BoxImageSisbi src={sisbi} alt="SISBI" />
          <BoxImageMaisIntegridade src={maisIntegridade} />
          <BoxImageMapa src={mapa} alt="Mapa" />
        </BoxImageContainer>
      </ContatosESelosContainer>
      <Footer />
    </HomeContainer>
  );
};
export default Historia;
